import { signOut } from '@features/auth/api/sign-out';
import { handleApiError } from '@src/lib/react-query';
import { useLoader } from '@src/providers/loader/loader-context';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

export type LogoutButtonProps = {
  /* The state of the drawer component the button is nested in */
  open: boolean;
};

export default function useLogout() {
  const { dispatch } = useLoader();
  const navigate = useNavigate();
  const startLoader = () =>
    dispatch({
      type: 'startLoader',
      payload: { message: 'Signing you out' },
    });
  const stopLoader = () => dispatch({ type: 'stopLoader' });

  const { mutate, isSuccess } = useMutation({
    mutationFn: signOut,
    onMutate: () => startLoader(),
    onSuccess: () => {
      stopLoader();
      void navigate({ to: '/login' });
    },
    onError: (error) => {
      stopLoader();
      handleApiError(error, 'Log out failed');
    },
  });

  const handleLogout = () => {
    mutate();
  };
  return { handleLogout, mutate, isSuccess };
}
